export const data = [
  {
    id: "0",
    question: "Which letter of the alphabet has the most water?",
    answer: "C",
    variants: [`A`, `B`, `C`]
  },
  {
    id: "1",
    question: "What kind of dog keeps the best time?",
    answer: "Watchdog",
    variants: [`Watchdog`, `hotdog`, `Cutedog`]
  },
  {
    id: "2",
    question:
      "What time of day, when written in a capital letters, is the same forwards, backwards and upside down?",
    answer: "Noon",
    variants: [`Morning`, `Noon`, `Evening`]
  },

  {
    id: "3",
    question: "What has a face and two hands but no arms or legs?",
    answer: "Clock",
    variants: [`Clock`, `Watch`, `Person`]
  },
  {
    id: "4",
    question:
      "What five-letter word becomes shorter when you add two letters to it?",
    answer: "Short",
    variants: [`Long`, `Short`, `Little`]
  },

  {
    id: "5",
    question: "What has a neck but no head?",
    answer: "Bottle",
    variants: [`Pan`, `Bottle`, `Plate`]
  },

  {
    id: "6",
    question:
      "What starts with a 'P', ends with an 'E' and has thousands of letters?",
    answer: "Post Office",
    variants: [`Letter`, `Envelope`, `Post Office`]
  },
  {
    id: "7",
    question: "What has to be broken before you can eat it?",
    answer: "Egg",
    variants: [`Bread`, `Banana`, `Egg`]
  },
  {
    id: "8",
    question: "What begins with T, ends with T and has T in it?",
    answer: "Teapot",
    variants: [`Teapot`, `Teacup`, `Teatree`]
  },
  {
    id: "9",
    question: "Teddy bears are never hungry because they are always what?",
    answer: "Stuffed",
    variants: [`Full`, `Stuffed`, `Sleep`]
  },
  {
    id: "10",
    question: "What belongs to you but others use it more than you do?",
    answer: "Name",
    variants: [`Reputation`, `Name`, `Nickname`]
  },
  {
    id: "11",
    question: "The more you take aways, the larger it becomes? What is it?",
    answer: "Hole",
    variants: [`Money`, `knowledge`, `Hole`]
  },
  {
    id: "12",
    question: "What is full of holes, but can still hold a lot of water?",
    answer: "Sponge",
    variants: [`River`, `Sponge`, `Sea`]
  },
  {
    id: "13",
    question: "Where do fish keep their money?",
    answer: "Riverbank",
    variants: [`Pool`, `Riverbank`, `River`]
  },
  {
    id: "14",
    question:
      "The more of them you take, the more you leave behind. What are they?",
    answer: "Footsteps",
    variants: [`Shadow`, `Footsteps`, `Footsprints`]
  },
  {
    id: "15",
    question: "What is that you will break everytime you name it?",
    answer: "Silence",
    variants: [`End`, `Silence`, `Stop`]
  },

  {
    id: "16",
    question: "What flies without wings?",
    answer: "Time",
    variants: [`Airplane`, `Time`, `Insect`]
  },
  {
    id: "17",
    question: "What turns everything around, but does not move?",
    answer: "Mirror",
    variants: [`Wall`, `Mirror`, `Closet`]
  },

  {
    id: "18",
    question: "What word looks the same upside down and backwards?",
    answer: "Swims",
    variants: [`Race`, `Swims`, `Now`]
  },
  {
    id: "19",
    question: "What kind of fish chases a mouse?",
    answer: "Catfish",
    variants: [`Catfish`, `Shark`, `Tuna`]
  },

  {
    id: "20",
    question: "What's the difference between here and there?",
    answer: "T",
    variants: [`R`, `T`, `E`]
  },

  {
    id: "21",
    question: "Take off my skin and I won't cry, but you will, What am I?",
    answer: "Onion",
    variants: [`Garlic`, `Carrot`, `Onion`]
  },
  {
    id: "22",
    question:
      "What doesn't get any wetter, no matter how much rain falls on it?",
    answer: "Water",
    variants: [`Water`, `Rain`, `River`]
  },
  {
    id: "23",
    question: "What sits in a corner while traveling all around the world?",
    answer: "Stamp",
    variants: [`Letter`, `Stamp`, `Wall`]
  },

  {
    id: "24",
    question: "What is round on both ends and hi in the middle?",
    answer: "Ohio",
    variants: [`Onion`, `Ohio`, `OMG`]
  },
  {
    id: "25",
    question: "What do you call a dog that sweats so much?",
    answer: "Hotdog",
    variants: [`Watchdog`, `Hotdog`, `Puppy`]
  },

  {
    id: "26",
    question: "What rains at the north pole?",
    answer: "Reindeer",
    variants: [`Deer`, `Rain`, `Reindeer`]
  },

  {
    id: "27",
    question:
      "What body part is pronounced as one letter but written with three, only two different letters are used?",
    answer: "Eye",
    variants: [`Arm`, `Eye`, `Ear`]
  },

  {
    id: "28",
    question:
      "Feed me and I live, give me something to drink and i'll die, What am I?",
    answer: "Fire",
    variants: [`Light`, `Fire`, `Air`]
  },

  {
    id: "29",
    question: "A shower that lights up the sky",
    answer: "Meteor",
    variants: [`Meteor`, `Rain`, `Star`]
  },

  {
    id: "30",
    question: "Commits friendly home invasions one night a year",
    answer: "Santa claus",
    variants: [`Robber`, `Santa claus`, `Police`]
  },
  {
    id: "31",
    question: "What has a ring, but no finger?",
    answer: "Telephone",
    variants: [`Television`, `Telephone`, `Telegram`]
  },

  {
    id: "32",
    question: "What is harder to catch the faster you run?",
    answer: "Breath",
    variants: [`Air`, `Breath`, `Fire`]
  },
  {
    id: "33",
    question: "What invention lets you look right through a wall?",
    answer: "Window",
    variants: [`Mirror`, `Window`, `Door`]
  },

  {
    id: "34",
    question: "What is a witch's favorite school subject?",
    answer: "Spelling",
    variants: [`Reading`, `Spelling`, `Writing`]
  },
  {
    id: "35",
    question: "What is an aliens favourite sport?",
    answer: "Spaceball",
    variants: [`Football`, `Spaceball`, `Baseball`]
  },
  {
    id: "36",
    question: "What is the saddest fruit?",
    answer: "Blueberry",
    variants: [`Orange`, `Blueberry`, `Apple`]
  },

  {
    id: "37",
    question: "What is easy to get into, and hard to get out of?",
    answer: "Trouble",
    variants: [`Cave`, `House`, `Trouble`]
  },

  {
    id: "38",
    question:
      "When you have me, you feel like sharing me. But, if you do share me, you don't have me. What am I?",
    answer: "Secret",
    variants: [`Money`, `Secret`, `Time`]
  },

  {
    id: "39",
    question:
      "It is an insect, and the first part of its name is the name of another insect. What is it?",
    answer: "Beetle",
    variants: [`Butterfly`, `Beetle`, `Bee`]
  },
  {
    id: "40",
    question:
      "What english word retains the same pronunciation, even after you take away four of its five letters?",
    answer: "Queue",
    variants: [`Huge`, `Queue`, `Milk`]
  },

  {
    id: "41",
    question:
      "What word of five letters has only one left when two letters are removed?",
    answer: "Stone",
    variants: [`Hello`, `Stone`, `There`]
  },
  {
    id: "42",
    question: "How many 9's are there between 1 and 100?",
    answer: "Twenty",
    variants: [`Thirty`, `Fourty`, `Twenty`]
  },
  {
    id: "43",
    question: "Which vehicle is spelled the same forwards and backwards?",
    answer: "Racecar",
    variants: [`Bicycle`, `Airplane`, `Racecar`]
  },
  {
    id: "44",
    question:
      "I am lighter than air but a million men cannot lift me up, What am I?",
    answer: "Bubble",
    variants: [`Mist`, `Bubble`, `Ballon`]
  },

  {
    id: "45",
    question:
      "What object has keys that open no locks, space but no room, and you can enter but not go in?",
    answer: "Keyboard",
    variants: [`Keyring`, `Keychain`, `Keyboard`]
  }
];
